<template>
  <div class="meetingItem">
    <!-- Mobile -->
    <div
      v-if="($mq === 'mobile' || $mq === 'tablet') && !isIE"
      class="mobile"
      :class="`${$mq}Mode`"
    >
      <div class="title defaultCursor">
        {{ label }}
      </div>
      <SwipeOut
        ref="swipeMeeting"
        :disabled="!meeting || !Object.entries(meeting).length
          || ['completed', 'cancelled', 'pending', 'on_hold'].includes(meeting.status)
          || !isNextSession"
      >
        <template>
          <el-row
            id="layoutMobile"
            class="layout layoutMobile"
            :gutter="15"
          >
            <el-col
              class="sessionName"
              :span="colResponse.one"
            >
              <div
                v-if="meetingIndex === 0"
                class="sessionNameWrapper"
              >
                {{ meetingIndex === 0 ? $t(`session.${session}`) : ' ' }}
                <el-tooltip
                  v-if="isNextSession && (session.split('_')[1] > 3 && session.split('_')[1] < 13)"
                  style="padding-left: 5px;"
                  effect="dark"
                  placement="top"
                  :content="tooltipContent"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </el-col>

            <el-col
              class="meetingTime"
              :span="colResponse.two"
            >
              <div class="schedulerLayout">
                <div class="left">
                  <CoachScheduler
                    v-if="!['completed', 'cancelled', 'pending', 'on_hold'].includes(meeting.status)
                      && policyAgreed
                      && isNextSession"
                    :coach-name="`${coach.first_name} ${coach.last_name}`"
                    :meeting-time="meeting.start_time"
                    :reset-date="false"
                    :disabled="['completed', 'cancelled', 'pending', 'on_hold']
                      .includes(meeting.status)
                      || !isNextSession"
                    :prop-loading="propLoading"
                    :icon="schedulerIcon"
                    :meeting-type="sessionType"
                    :pulse-debrief-warn="pulseDebriefWarn"
                    :placeholder="$t('leader.coach.selectDayTime')"
                    @meetingCreated="meetingCreated"
                  />

                  <div
                    v-else-if="!['completed', 'cancelled', 'pending', 'on_hold']
                      .includes(meeting.status)
                      && !policyAgreed
                      && isNextSession"
                    @click="openPolicyModal"
                  >
                    <el-input
                      :disabled="true"
                      :value="meeting.start_time
                        ? meeting.start_time : $t('leader.coach.selectDayTime')"
                      :suffix-icon="(isNextSession && !meeting.start_time) ? 'el-icon-date' : ''"
                      class="policyInput"
                    />
                  </div>

                  <el-tooltip
                    v-else
                    class="tooltip"
                    effect="dark"
                    :content="$t('leader.coach.processTooltip')"
                    placement="top"
                    :disabled="!isNextSession || meeting.status === 'cancelled'"
                  >
                    <el-input
                      class="cancelledMeeting"
                      :disabled="true"
                      :value="meeting.start_time
                        ? meeting.start_time : $t('leader.coach.selectDayTime')"
                      :suffix-icon="(isNextSession && !meeting.start_time) ? 'el-icon-date' : ''"
                    />
                  </el-tooltip>
                </div>
              </div>
            </el-col>
          </el-row>
        </template>

        <div
          v-if="!(['completed', 'cancelled', 'pending', 'on_hold'].includes(meeting.status)
            || !meeting
            || !Object.entries(meeting).length
            || !isNextSession)"
          class="swipeArrow"
        >
          <img
            src="@/assets/icon/swipeArrow.png"
            alt="arrow"
          />
        </div>

        <template v-slot:right>
          <div
            class="swipeout-action red"
            @click="cancelMeeting"
          >
            <i class="el-icon-circle-close"></i>
            <div>{{ $t('common.cancel') }}</div>
          </div>
        </template>
      </SwipeOut>
    </div>

    <!-- Desktop -->
    <div
      v-else
      class="layout desktop"
    >
      <div class="col1 first defaultCursor">
        {{ label }}
      </div>

      <div
        v-if="meetingIndex === 0"
        class="col2 defaultCursor"
      >
        <div class="sessionNameWrapper">
          {{ $t(`session.${session}`) }}
          <el-tooltip
            v-if="isNextSession && (session.split('_')[1] > 3 && session.split('_')[1] < 13)"
            style="padding-left: 5px;"
            effect="dark"
            placement="top"
            :content="tooltipContent"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
      </div>
      <div
        v-else
        class="col2"
      ></div>

      <div class="col3">
        <div class="schedulerLayout">
          <div class="left">
            <CoachScheduler
              v-if="!['completed', 'cancelled', 'pending', 'on_hold'].includes(meeting.status)
                && policyAgreed
                && isNextSession"
              :coach-name="`${coach.first_name} ${coach.last_name}`"
              :meeting-time="meeting.start_time"
              :reset-date="false"
              :disabled="['completed', 'cancelled', 'pending', 'on_hold'].includes(meeting.status)
                || !isNextSession"
              :prop-loading="propLoading"
              :icon="schedulerIcon"
              :meeting-type="sessionType"
              :pulse-debrief-warn="pulseDebriefWarn"
              :placeholder="$t('leader.coach.selectDayTime')"
              @meetingCreated="meetingCreated"
            />

            <div
              v-else-if="!['completed', 'cancelled', 'pending', 'on_hold']
                .includes(meeting.status)
                && !policyAgreed
                && isNextSession"
              @click="openPolicyModal"
            >
              <el-input
                :disabled="true"
                :value="meeting.start_time ? meeting.start_time : $t('leader.coach.selectDayTime')"
                :suffix-icon="(isNextSession && !meeting.start_time) ? 'el-icon-date' : ''"
                class="policyInput"
              />
            </div>

            <el-tooltip
              v-else
              class="tooltip"
              effect="dark"
              :content="'You will receive an email when it is '
                + 'time to schedule your next coaching session'"
              placement="top"
              :disabled="!isNextSession || meeting.status === 'cancelled'"
            >
              <el-input
                class="cancelledMeeting"
                :disabled="true"
                :value="meeting.start_time ? meeting.start_time : $t('leader.coach.selectDayTime')"
                :suffix-icon="(isNextSession && !meeting.start_time) ? 'el-icon-date' : ''"
              />
            </el-tooltip>
          </div>

          <div class="right">
            <el-tooltip
              v-if="meeting.status
                && (!['completed', 'cancelled', 'pending', 'on_hold'].includes(meeting.status)
                  && isNextSession)"
              class="tooltip"
              effect="dark"
              :content="$t('leader.coach.cancelMeeting')"
              placement="top"
            >
              <el-button
                icon="el-icon-delete"
                type="text"
                circle
                @click="cancelMeeting"
              />
            </el-tooltip>
          </div>
        </div>
      </div>

      <div class="col4 defaultCursor">
        <span v-if="meeting.status">
          {{ meeting.status ? $t(`meetingStatus.${meeting.status}`) : '' }}
        </span>
        <span v-else-if="meeting && Object.entries(meeting).length && isNextSession">
          {{ $t('meetingStatus.pending') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CoachScheduler from '../coach/scheduler/CoachScheduler.vue';

export default {
  components: {
    CoachScheduler,
    SwipeOut: () => import(/* webpackChunkName: "swipeAction" */ 'vue-swipe-actions').then((m) => m.SwipeOut), // async components loading to avoid IE loading it
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    session: {
      type: String,
      default: 'session_1',
    },

    meetingIndex: {
      type: Number,
      default: 0,
    },

    meeting: {
      type: Object,
      default: null,
    },

    isNextSession: {
      type: Boolean,
      default: true,
    },

    policyAgreed: {
      type: Boolean,
      default: true,
    },

    propLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      coach: (state) => state.myCoach.coach,
      profile: (state) => state.user.profile,
    }),

    ...mapGetters('processStatus', {
      currentSession: 'currentSession',
    }),

    sessionType() {
      if (this.session === this.currentSession) return 'rescheduleSession';
      return 'nextSession';
    },

    schedulerIcon() {
      let icon;
      switch (this.meeting.status) {
        case 'cancelled':
          icon = 'el-icon-close';
          break;
        case 'confirmed':
        case 'rescheduled':
          icon = 'el-icon-refresh';
          break;
        default:
          icon = 'el-icon-date';
      }
      return icon;
    },

    colResponse() {
      const col = {};
      if (this.$mq === 'mobile') {
        col.one = 9;
        col.two = 15;
      } else {
        col.one = 8;
        col.two = 16;
      }
      return col;
    },

    tooltipContent() {
      let text = this.$t('leader.coach.minimum8days');
      const pulseSession = ['7', '10', '13'];
      if (this.session && this.session.split('_') && pulseSession.includes(this.session.split('_')[1])) {
        text = this.$t('leader.coach.minimum15days');
      }
      return text;
    },

    pulseDebriefWarn() {
      let flag = false;
      const pulseSession = ['7', '10', '13'];
      if (this.session && this.session.split('_') && pulseSession.includes(this.session.split('_')[1])) {
        flag = true;
      }
      return flag;
    },

    isIE() {
      return navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    },
  },

  methods: {
    cancelMeeting() {
      this.$emit('cancelMeeting');
      this.closeAll();
    },
    meetingCreated(newMeeting) {
      this.$emit('meetingCreated', newMeeting);
      this.closeAll();
    },
    closeAll() {
      if (this.$refs.swipeMeeting) {
        this.$refs.swipeMeeting.closeActions();
      }
    },
    openPolicyModal() {
      this.$EventBus.$emit('open_policy_modal');
    },
  },
};
</script>

<style lang="scss" scoped>
.meetingItem {
  .sessionNameWrapper {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .schedulerLayout {
    display: flex;

    .right {
      width: 42px;

      .el-button {
        color: var(--themeFontColor);
      }
    }
  }

  .mobile {
    .title {
      font-weight: bold;
      margin-bottom: 15px;
    }

    #layoutMobile {
      display: block;
      width: 100%;
      padding: 0 12px 0 0;
    }

    .swipeout {
      width: 100%;
      line-height: 55px;

      .swipeout-content {
        padding-right: 10px;

        .el-col {
          // For not auto collapse
          min-height: 1px;
        }

        .swipeArrow {
          display: flex;
          position: absolute;
          align-items: center;
          width: 17px;
          height: 100%;
          top: 0;
          right: 3px;

          img {
            width: 100%;
            height: 40%;
          }
        }
      }

      .swipeout-action {
        width: 81px;
        text-align: center;
        line-height: 1.5;
        font-size: 13px;

        i {
          display: none;
        }

        div {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &.black {
          background: #343434;
        }

        &.red {
          background: #b00000;
        }
      }

      .left {
        width: 100%;
      }
    }

    &.mobileMode {
      .layoutMobile {
        margin-left: 0 !important;
        display: flex !important;

        .sessionName {
          padding-left: 0 !important;
        }
      }

      .swipeout {
        line-height: 2;

        .swipeArrow {
          width: 12px;
        }
      }
    }
  }

  .desktop {
    line-height: 85px;
  }
}
</style>

<style lang="scss">
.el-input.cancelledMeeting {
  .el-input__inner {
    cursor: default;
    border-radius: 20px !important;
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.2);
    color: #212121;
  }

  .el-input__suffix {
    color: #212121;
  }
}

.el-input.policyInput {
  .el-input__inner {
    cursor: default;
    border-radius: 20px !important;
    border-color: rgba(255, 255, 255, 0.2);
    pointer-events: none;
  }
}
</style>
